'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.types = undefined;

var _babelTypesPatch = require('./util/babelTypesPatch');

var _babelTypesPatch2 = _interopRequireDefault(_babelTypesPatch);

var _lscNodeTypes = require('./lscNodeTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Avoiding `import` here to ensure compatibility with environments that have
// asynchronous `import`.
var t = require('babel-types');

(0, _babelTypesPatch2.default)(t);
(0, _lscNodeTypes.registerLightscriptNodeTypes)(t);

exports.types = t;
exports.default = t;